import React from 'react'
import {  Button } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { OPEN_DIALOG } from '../redux/dialogReducer'
import { CLOSE_ALERT } from '../redux/alertReducer'
import AssignUserToAcsDffEntitlementDialog from './dialog/assignUserToAcsDffEntitlement'

const AssignUserToAcsDffEntitlementButton = ({
  targetEntitlement,
  setNeedsFetchData,
}) => {
  const dispatch = useDispatch()

  const buttonLabel = 'Assign user to Entitlement'

  return <Button
      variant="contained"
      size="small"
      color="primary"
      onClick={() => {
        dispatch({
          type: OPEN_DIALOG,
          component: AssignUserToAcsDffEntitlementDialog,
          props: {
            targetEntitlement,
            setNeedsFetchData,
          },
        })
        dispatch({
          type: CLOSE_ALERT,
        })
      }}
    >
      {buttonLabel}
    </Button>
}

export default AssignUserToAcsDffEntitlementButton
